import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";

import {
  CarouselStyled,
  ContainerStyled,
  HeaderStyled,
  MarqueeItemStyled,
  StaticTechListStyled,
  StaticTechItemStyled,
} from "./Technologies.styled";

interface TechnologiesSectionProps {
  className?: string;
  header: string;
  technologies: string[];
}

export const TechnologiesSection = ({
  className,
  header,
  technologies,
}: TechnologiesSectionProps) => {
  const [isClient, setIsClient] = useState(false);

  // Detect client-side hydration
  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <ContainerStyled className={className}>
      <HeaderStyled>{header}</HeaderStyled>
      <CarouselStyled>
        {/* Server-side rendered list for SEO */}
        {!isClient && (
          <StaticTechListStyled>
            {technologies.map((tech, index) => (
              <StaticTechItemStyled key={index}>{tech}</StaticTechItemStyled>
            ))}
          </StaticTechListStyled>
        )}

        {/* Client-side animated marquee */}
        {isClient && (
          <Marquee speed={30}>
            {technologies.map((tech, index) => (
              <MarqueeItemStyled key={index}>{tech}</MarqueeItemStyled>
            ))}
          </Marquee>
        )}
      </CarouselStyled>
    </ContainerStyled>
  );
};
